import React from 'react';
import Popover from './Popover';
import Widget from './Widget';
import Sidetab from './Sidetab';
import Popup from './Popup';
import Slider from './Slider';

/** @param {FF.ContentfulTypeform} props */
export default function TypeformWrapper(props) {
  const { buttonIcon, buttonText, presentationType } = props;

  const hasButton = Boolean(buttonIcon || buttonText);
  if (presentationType !== 'Inline' && !hasButton) {
    throw new Error(
      `Form type "${presentationType}" requires "Button Icon" and/or "Button Text"`,
    );
  }
  switch (presentationType) {
    case 'Inline': {
      return <Widget {...props} />;
    }
    case 'Popover': {
      return <Popover {...props} />;
    }
    case 'Side Tab': {
      return <Sidetab {...props} />;
    }
    case 'Popup w/ Inline Button': {
      return <Popup {...props} />;
    }
    case 'Slider w/ Inline Button': {
      return <Slider {...props} />;
    }
    default:
      throw new Error('Unknown Presentation Type given');
  }
}
